export const VEZHAM_PREFIX = '@vezham';
export const NEXTUI_PREFIX = '@heroui';
export const HEROUI_PREFIX = '@v0xoss';

export const NEXTUI_PROVIDER = 'HeroUIProvider';
export const HEROUI_PROVIDER = 'V0xdsProvider';

export const NEXTUI_PLUGIN = 'heroui';
export const HEROUI_PLUGIN = 'vezham';

export const NEXTUI_CSS_VARIABLES_PREFIX = '--heroui-';
export const HEROUI_CSS_VARIABLES_PREFIX = '--v0x-';

export const EXTRA_FILES = ['.storybook'];
